<template>
    <ConfettiExplosion v-if="showConfetti" :particleCount="300" :force="1" />
    <div class="search-container">
      <v-card
        class="mx-auto pa-12 pb-8"
        elevation="8"
        width="650"
        id="transparent"
      >

        <div class="text-textcolor" style="display: flex; align-items: baseline;">
          <h1>Gift</h1>
        </div>
  
        <div class="d-flex align-center justify-space-between">
          <v-text-field
            placeholder="Enter your gift key"
            v-model="keyTextField"
            append-icon="mdi-crown"
            hide-details="auto"
            outlined
            dense
            class="search-bar flex-grow-1"
            @keydown.enter="claim"
            @click:append="claim"
          ></v-text-field>
        </div>
        <br>
        <div v-if="showCaptcha">
          <CaptchaWidget ref="altchaWidget" @captcha-verified="handleCaptchaVerified"></CaptchaWidget>
        </div>
      </v-card>
    </div>
  </template>
  
  <script>
  import ConfettiExplosion from "vue-confetti-explosion";
  import { mapGetters } from 'vuex';
  import { useToast } from 'vue-toastification';
  import 'vue-toastification/dist/index.css';
  import CaptchaWidget from '@/components/CaptchaWidget.vue';
  
  export default {
    data() {
      return {
        keyTextField: '',
        userdata: JSON.parse(localStorage.getItem('userdata')),
        response: '',
        captcha_payload: null,
        showConfetti: false,
        showCaptcha: true,
      };
    },
    computed: {
      ...mapGetters(['backend']),
    },
    components: {
      CaptchaWidget,
      ConfettiExplosion
    },
    methods: {
    triggerConfetti() {
        this.showConfetti = true;
        setTimeout(() => {
        this.showConfetti = false;
        }, 5000);
    },
  handleCaptchaVerified(payload) {
    this.captcha_payload = payload;
  },
  async claim() {
    const key = this.keyTextField;
    const token = localStorage.getItem("Authorization");
    const toast = useToast();

    try {
      let response = await this.$axios.post(`${this.backend}/api/gift/claim`, { key: key, captcha_payload: this.captcha_payload }, {
        headers: {
          "Authorization": token,
        }
      });
      this.response = response.data;
      const userdata2 = JSON.parse(localStorage.getItem('userdata'))
      userdata2.research += response.data.amount;
      localStorage.setItem('userdata', JSON.stringify(userdata2));
      this.triggerConfetti();

    } catch (err) {
      console.error("Error claiming gift:", err);
      if (err.response) {
        toast.error((err.response.data.error).toString());
      } else {
        toast.error("An unexpected error occurred.");
      }

      this.showCaptcha = false;
      this.$nextTick(() => {
        this.showCaptcha = true;
      });
    }
    this.captcha_payload = null;
  }
}
  };
  </script>
  
  <style scoped>
  .search-container {
    display: flex;
    align-items: center; 
    height: 100vh;
  }
  
  #transparent {
    background-color: transparent !important; 
    box-shadow: none !important;
  }
  
  .text-textcolor {
    color: #333; 
  }
  
  .search-bar {
    max-width: 100%;
  }
  </style>
  